import axios from "axios";
import xlsx from "xlsx";

import {
	SET_PLANO_CAMPAIGNS,
	SET_SHARED_PLANO_CAMPAIGNS,
	SET_VIEW_CAMPAIGN_PANE,
	SET_SHARING_USERS
} from "./types";
import { newUrl } from "../../utility";

export const fetchPlanoCampaigns = () => dispatch => {
	axios
		.post(
			newUrl + "/getPlanoCampaigns",
			{},
			{ headers: { authorization: localStorage.getItem("plano_token") } }
		)
		.then(
			success => {
				if (success.data) {
					dispatch({
						type: SET_PLANO_CAMPAIGNS,
						payload: success.data.data
					});
				}
			},
			error => {
				if (error) {
					console.log(error);
				}
			}
		);
};

export const fetchSharedPlanoCampaigns = () => dispatch => {
	axios
		.post(
			newUrl + "/fetchSharedPlanoCampaigns",
			{},
			{ headers: { authorization: localStorage.getItem("plano_token") } }
		)
		.then(
			success => {
				if (success.data) {
					dispatch({
						type: SET_SHARED_PLANO_CAMPAIGNS,
						payload: success.data.data
					});
				}
			},
			error => {
				if (error) {
					console.log(error);
				}
			}
		);
};

export const deletePlanoCampaign = item => dispatch => {
	axios
		.post(
			newUrl + "/deletePlanoCampaign",
			{ campaign_id: item._id },
			{ headers: { authorization: localStorage.getItem("plano_token") } }
		)
		.then(
			(success, error) => {
				if (success.data) {
					fetchPlanoCampaigns()(dispatch);
				}
			},
			error => {
				if (error) {
					console.log(error);
				}
			}
		);
};

export const sharePlanoCampaign = item => dispatch => {
	axios
		.post(
			newUrl + "/sharePlanoCampaign",
			{ campaign_id: item._id },
			{ headers: { authorization: localStorage.getItem("plano_token") } }
		)
		.then(
			success => {
				if (success.data) {
					fetchPlanoCampaigns()(dispatch);
				}
			},
			error => {
				if (error) {
					console.log(error);
				}
			}
		);
};

export const loadSharingUsers = () => dispatch => {
	axios
		.post(
			newUrl + "/loadSharingUsers",
			{},
			{ headers: { authorization: localStorage.getItem("plano_token") } }
		)
		.then(
			success => {
				if (success.data) {
					let tempSharingUsers = success.data.data.map(item => {
						return { label: item.name, value: item.id };
					});
					dispatch({
						type: SET_SHARING_USERS,
						payload: tempSharingUsers
					});
				}
			},
			error => {
				if (error) {
					console.log(error);
				}
			}
		);
};

export const setSharingUsers = (
	selectedSharingUsers,
	campaign_id
) => dispatch => {
	axios
		.post(
			newUrl + "/setSharingUsers",
			{ selectedSharingUsers: selectedSharingUsers, campaign_id: campaign_id },
			{ headers: { authorization: localStorage.getItem("plano_token") } }
		)
		.then(
			success => {
				if (success.data) {
					fetchPlanoCampaigns()(dispatch);
				}
			},
			error => {
				if (error) {
					console.log(error);
				}
			}
		);
};

export const setApprovalStatus = (approval_status, campaign_id) => dispatch => {
	axios
		.post(
			newUrl + "/setApprovalStatus",
			{ approval_status: approval_status, campaign_id: campaign_id },
			{ headers: { authorization: localStorage.getItem("plano_token") } }
		)
		.then(
			success => {
				if (success.data) {
					fetchSharedPlanoCampaigns()(dispatch);
				}
			},
			error => {
				if (error) {
					console.log(error);
				}
			}
		);
};

export const setViewCampaignPane = item => dispatch => {
	dispatch({
		type: SET_VIEW_CAMPAIGN_PANE,
		payload: item
	});
};

export const downloadPPT = (campaign_id, emails) => dispatch => {
	axios
		.post(
			newUrl + "/generatePlanoPPT",
			{ campaign_id: campaign_id, emails: emails },
			{ headers: { authorization: localStorage.getItem("plano_token") } }
		)
		.then(
			success => {
				if (success.data) {
					console.log("PPT request Sent");
				}
			},
			error => {
				if (error) {
					console.log(error);
				}
			}
		);
};

export const exportExcel = campaignData => dispatch => {
	let headers = {
		site_code: "Site Code",
		city: "City",
		location: "Location",
		media_type: "Media Type",
		width: "Width",
		height: "Height",
		locality: "Locality",
		latitude: "Latitude",
		longitude: "Longitude",
		media_owner: "Media Owner",
		availability: "Availability",
		url: "URL",
		region:"Region",
		poi:"Point of Interests",
		sec_classification: "Audience Profile"
	};

	axios
		.post(
			newUrl + "/getPlanoCampaignExcel",
			{ campaign_id: campaignData._id },
			{ headers: { authorization: localStorage.getItem("plano_token") } }
		)
		.then(
			success => {
				if (success.data.data) {
					console.log("Got Excel Data");

					let sitesData = success.data.data;

					let items = [];

					sitesData.map((item, index) => {
						const {
							site_code,
							city,
							location,
							media_type,
							width,
							height,
							locality,
							latitude,
							longitude,
							media_owner,
							availability,
							site_map,
							poi,
							sec_classification,
							region
						} = item;

						const url = site_map;
						
						var obj={
							[headers.site_code]: site_code ? site_code : "NA",
							[headers.city]: city ? city : "NA",
							[headers.location]: location ? location : "NA",
							[headers.media_type]: media_type ? media_type : "NA",
							[headers.width]: width ? width : "NA",
							[headers.height]: height ? height : "NA",
							[headers.locality]: locality ? locality : "NA",
							[headers.latitude]: latitude ? latitude : "NA",
							[headers.longitude]: longitude ? longitude : "NA",
							[headers.media_owner]: media_owner ? media_owner : "NA",
							[headers.availability]: availability ? availability : "NA",
							[headers.url]: url,
							[headers.region]: region ? region : "",
							[headers.sec_classification]: sec_classification ? sec_classification.toString():""
						}

						if(poi) {
							poi.map((p,i) => {
								obj['POI '+(i+1)] = p
							})
						}
						items.push(obj);
						return null;
					});

					let dataWS = xlsx.utils.json_to_sheet(items, { headers: "test" });

					let wb = xlsx.utils.book_new();
					xlsx.utils.book_append_sheet(wb, dataWS, campaignData.campaignName);

					xlsx.writeFile(wb, campaignData.campaignName + ".xlsx");

					// exportCSVFile(headers, items, campaignData.campaignName);
				}
			},
			error => {
				if (error) {
					console.log(error);
				}
			}
		);
};

// function convertToCSV(objArray) {
// 	var array = typeof objArray !== "object" ? JSON.parse(objArray) : objArray;
// 	var str = "";

// 	for (var i = 0; i < array.length; i++) {
// 		var line = "";
// 		for (var index in array[i]) {
// 			if (line !== "") line += "\t";

// 			line += array[i][index];
// 		}

// 		str += line + "\r\n";
// 	}

// 	return str;
// }

// function exportCSVFile(headers, items, fileTitle) {
// 	if (headers) {
// 		items.unshift(headers);
// 	}

// 	// Convert Object to JSON
// 	var jsonObject = JSON.stringify(items);

// 	var csv = convertToCSV(jsonObject);

// 	var exportedFilenmae = fileTitle + ".csv" || "export.csv";

// 	var blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
// 	if (navigator.msSaveBlob) {
// 		// IE 10+
// 		navigator.msSaveBlob(blob, exportedFilenmae);
// 	} else {
// 		var link = document.createElement("a");
// 		if (link.download !== undefined) {
// 			// feature detection
// 			// Browsers that support HTML5 download attribute
// 			var url = URL.createObjectURL(blob);
// 			link.setAttribute("href", url);
// 			link.setAttribute("download", exportedFilenmae);
// 			link.style.visibility = "hidden";
// 			document.body.appendChild(link);
// 			link.click();
// 			document.body.removeChild(link);
// 		}
// 	}
// }



// WEBPACK FOOTER //
// ./src/v3/actions/planoCampaignActions.js